import { render, staticRenderFns } from "./AdminAccountTabSources.vue?vue&type=template&id=3ee13deb&scoped=true"
import script from "./AdminAccountTabSources.vue?vue&type=script&lang=js"
export * from "./AdminAccountTabSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee13deb",
  null
  
)

export default component.exports